import React from "react";

export default function ShapeOverlayRenderer({ shape, color, flipH, flipV }) {
  const stroke = 3;
  let content = null;

  if (shape === "rectangle") {
    content = (
      <rect
        x="2"
        y="2"
        width="96"
        height="96"
        fill="none"
        stroke={color}
        strokeWidth={stroke}
        rx="4"
      />
    );
  } else if (shape === "circle") {
    content = <circle cx="50" cy="50" r="45" fill="none" stroke={color} strokeWidth={stroke} />;
  } else if (shape === "arrow") {
    const x1 = flipH ? 95 : 5;
    const x2 = flipH ? 5 : 95;
    const y1 = flipV ? 95 : 5;
    const y2 = flipV ? 5 : 95;
    const mid = "arrowhead-" + Math.random().toString(36).slice(2, 8);
    content = (
      <g>
        <defs>
          <marker id={mid} markerWidth="10" markerHeight="10" refX="9" refY="3" orient="auto">
            <polygon points="0 0, 10 3, 0 6" fill={color} />
          </marker>
        </defs>
        <line
          x1={x1}
          y1={y1}
          x2={x2}
          y2={y2}
          stroke={color}
          strokeWidth={stroke}
          markerEnd={"url(#" + mid + ")"}
        />
      </g>
    );
  } else if (shape === "highlight") {
    content = <rect x="0" y="0" width="100" height="100" fill={color} fillOpacity="0.4" />;
  } else if (shape === "blur") {
    content = <rect x="0" y="0" width="100" height="100" fill="rgba(0,0,0,0.85)" />;
  }

  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 100 100"
      preserveAspectRatio="none"
      style={{ display: "block", pointerEvents: "none" }}
    >
      {content}
    </svg>
  );
}
